module.exports = __webpack_public_path__ + "img/2.562fc8de.jpg";